import { AxiosService } from './axios.service'
import { SearchService } from './search.service'

export class BuyWinService extends SearchService {
	static baseURL = 'compre-e-ganhe'

	static getListPartners() {
		return AxiosService.get(`${this.baseURL}/lista-parceiros`).then(
			({ data }) => data.data
		)
	}

	static getPartnerByInternalUrl(partner) {
		return AxiosService.get(
			`${this.baseURL}/parceiro-url-interna?internalURL=${partner}`
		).then(({ data }) => data.data)
	}
}
